import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { Onix } from '../../../models/Onix';
import { Lingua } from '../../../models/Lingua';
import { BookService } from './../../../services/book.service';

@Component({
  selector: 'app-lingua-selector',
  templateUrl: './lingua-selector.component.html',
  styleUrls: ['./lingua-selector.component.css'],
  providers: [
    BookService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LinguaSelectorComponent),
      multi: true
    }
  ]
})
export class LinguaSelectorComponent implements OnInit {
  tipologia: Onix;
  lingua: Onix;

  @Input() eraseable: boolean;
  @Output() removeNotify: EventEmitter<any> = new EventEmitter<any>();
  @Output() notify: EventEmitter<Onix> = new EventEmitter<Onix>();

  constructor(private bookService: BookService) { }

  ngOnInit() { }

  onModelChange(e) {
    this.propagateChange(new Lingua({
      tipologia: this.tipologia,
      lingua: this.lingua
    }))
  }

  onOnixChange(onix: Onix) {
    if (onix) {
      this.notify.emit(onix);
    }
  }

  eraseMe() {
    this.removeNotify.emit();
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj: Lingua) {
    // console.log('======= ************ writeValue', obj)
    if (obj) {
      this.tipologia = obj.tipologia;
      this.lingua = obj.lingua;
      // this.propagateChange(new Lingua({
      //   tipologia: this.tipologia,
      //   lingua: this.lingua
      // }))
    }
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/book/lingua-selector/lingua-selector.component.ts